// @flow
import styled from "styled-components";
import buildColor from "@fdr/static-ui/ColorPalette";
import { fontNormal } from "@fdr/static-ui/Typography";

export const HelpContainer = styled.section``;

export const HelpImageContainer = styled.div`
  background-color: ${buildColor("grey", "000")};
  display: flex;
  justify-content: center;
  box-shadow: 0 1px 0 0 ${buildColor("grey", "300")};
  z-index: 1;

  & > svg {
    height: 134px;
    width: 375px;
  }
`;

export const HelpTextContainer = styled.div`
  padding: ${({ hasMessage }) => (hasMessage ? " 12px 16px 16px" : "16px")};
  line-height: 125%;

  & > div:not(:last-child) {
    padding-bottom: 20px;
  }
`;

export const TextParaf = styled.div`
  color: ${buildColor("grey", "900")};
  font-size: 14px;
  font-family: ${fontNormal};
`;

export const InlineMessageWrapper = styled.div`
  padding: 16px 16px 0;
`;
